import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-packs',
  templateUrl: './packs.component.html',
  styleUrls: ['./packs.component.css']
})
export class PacksComponent implements OnInit {

  constructor() { }

  Resources = [
    {
      title: 'Vibrant Grass',
      description: 'You always thought the Grass in minecraft looked boring? Well then you should download this pack!',
      img: 'assets/images/Grass.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787665664244449280/VibrantGrass.zip'
    },
    {
      title: 'Better Paths',
      description: 'With this pack the Paths go down blocks.',
      img: 'assets/images/Path.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787666082948448260/BetterPaths.zip'
    },
    {
      title: 'Custom Netherite',
      status: 'By: GebackeneBanane',
      description: 'With this pack you have golden parts on your netherite armor.',
      img: 'assets/images/Netherite.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787702793669574726/Custom_Netherite.zip'
    },
    {
      title: 'Better Warped Forrest',
      description: 'When activating this the warped forrest becomes purple. :O',
      img: 'assets/images/Warped.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787703054060355584/BetterWarpedForrest.zip'
    },
    {
      title: 'Golden Enchantment Glint',
      status: 'By: Olivier_286',
      description: 'This pack lets your enchanted items be golden!',
      img: 'assets/images/GoldenGlint.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/793219954278400040/Golden_Enchanting_Glint.zip'
    },
  ];

  ngOnInit(): void {
  }

}
